// NOTE this file is kind of redundant, api/* files are already the only
// part of the app that interacts with backend, so we can just hardcode the endpoints there

// app
export const CONGA = '/v1/conga'

// auth - these use authUrl which already points to /v1/auth
export const AUTH_DEVICE_LOGIN = '/device/login'
export const AUTH_USER_LOGIN = '/user/login'
export const AUTH_USER_REGISTER = '/user/register'
export const AUTH_USER_RECOVERY = '/user/recovery'
export const AUTH_USER_RECOVERY_PASSWORD = '/user/recovery/password'

export const MFA = '/mfa'
export const MFA_SETUP = '/mfa/setup'
export const MFA_CONFIRM = '/mfa/setup/confirm'
export const MFA_REVOKE = '/mfa/revoke'

export const SESSION_REFRESH = '/oauth/token'

// user
export const USER = '/v1/user'
export const USER_ME = '/v1/user/me'
export const USER_PASSSWORD = '/v1/user/password'
export const USER_EMAIL_RESEND = '/v1/user/email/resend'
export const USER_ACTIVITY_LOG = '/v1/user/activity-log'
// unified trash: global deleted items across all collections (deletedBy = me)
export const USER_DELETED_ITEMS = '/v1/user/deleted-items'

// bookmarks
export const BOOKMARKS = '/v1/bookmarks'
export const COLLECTIONS = '/v1/collections'

// collection items (v2 API - polymorphic: bookmarks + notes)
export const COLLECTION_ITEMS = '/v2/collections'

// features
export const FEATURES = '/v1/features'

// version
export const VERSION = '/v1/version'
